import { createRouter, createWebHashHistory } from 'vue-router';
import { requireAuth, isLoggedIn } from '@/utils/auth';

/**
 * 路由
 * */
// 定义组件加载函数，添加错误处理
const loadComponent = (importFn) => {
    return () => {
        return importFn().catch(error => {
            // 如果是 ChunkLoadError，尝试刷新页面
            if (error.name === 'ChunkLoadError' || error.message?.includes('Loading chunk') || error.message?.includes('Loading hot update chunk')) {
                console.warn('Chunk 加载失败，尝试刷新页面:', error);
                // 在开发环境下，刷新页面可以解决 HMR chunk 问题
                if (process.env.NODE_ENV === 'development') {
                    window.location.reload();
                    return Promise.reject(error);
                }
            }
            // 其他错误直接抛出
            console.error('组件加载失败:', error);
            throw error;
        });
    };
};

const routes = [
    {
        path:'/',
        name:'首页',
        component:loadComponent(() => import("@/pages/index"))
    },

    {
        path:'/login',
        name:'登录注册',
        component:loadComponent(() => import("@/pages/login"))
    },
    {
        path:'/my',
        name:'我的',
        component:loadComponent(() => import("@/pages/my"))
    },
    {
        path:'/orders',
        name:'我的订单',
        component:loadComponent(() => import("@/pages/orders"))
    },
    {
        path:'/payment',
        name:'支付',
        component:loadComponent(() => import("@/pages/payment"))
    },
    {
        path:'/wallet',
        name:'商户钱包',
        component:loadComponent(() => import("@/pages/wallet"))
    },
    {
        path:'/package/:id',
        name:'套餐详情',
        component:loadComponent(() => import("@/pages/packageDetail"))
    },
    {
        path:'/package',
        name:'套餐详情',
        component:loadComponent(() => import("@/pages/packageDetail"))
    },
    {
        path:'/cart',
        name:'购物车',
        component:loadComponent(() => import("@/pages/cart"))
    },
    {
        path:'/faq',
        name:'常见问题',
        component:loadComponent(() => import("@/pages/faq"))
    },
    {
        path:'/about',
        name:'公司简介',
        component:loadComponent(() => import("@/pages/about"))
    },
    {
        path:'/privacy',
        name:'隐私政策',
        component:loadComponent(() => import("@/pages/privacy"))
    },


]
const router = createRouter({
    history:createWebHashHistory(),
    routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
    // 检查是否需要登录
    if (requireAuth(to.path) && !isLoggedIn()) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        });
    } else {
        next();
    }
});

// 添加路由错误处理
router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadError = error.message.match(pattern);
    const targetPath = router.currentRoute.value.fullPath;
    if (isChunkLoadError) {
        console.warn('路由 chunk 加载失败，尝试刷新页面');
        // 在开发环境下，刷新页面可以解决 HMR chunk 问题
        if (process.env.NODE_ENV === 'development') {
            window.location.reload();
        } else {
            // 生产环境下，可以尝试重新加载路由
            router.replace(targetPath);
        }
    }
});

export default router
